
import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

// API fonksiyonları
export const api = {
  // İletişim formu gönderme
  async sendContactMessage(data: {
    name: string
    email: string
    phone?: string
    subject?: string
    message: string
  }) {
    const response = await fetch(`${supabaseUrl}/functions/v1/contact-form`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseAnonKey}`
      },
      body: JSON.stringify(data)
    })
    return response.json()
  },

  // Blog yazılarını getirme
  async getBlogPosts(category?: string) {
    const url = new URL(`${supabaseUrl}/functions/v1/blog-posts`)
    if (category && category !== 'Tümü') {
      url.searchParams.set('category', category)
    }
    
    const response = await fetch(url.toString(), {
      headers: {
        'Authorization': `Bearer ${supabaseAnonKey}`
      }
    })
    return response.json()
  },

  // Tek blog yazısı getirme
  async getBlogPost(slug: string) {
    const url = new URL(`${supabaseUrl}/functions/v1/blog-posts`)
    url.searchParams.set('slug', slug)
    
    const response = await fetch(url.toString(), {
      headers: {
        'Authorization': `Bearer ${supabaseAnonKey}`
      }
    })
    return response.json()
  },

  // Eğitim kaydı gönderme
  async sendTrainingRegistration(data: {
    name: string
    email: string
    phone?: string
    training_type: string
    message?: string
  }) {
    const response = await fetch(`${supabaseUrl}/functions/v1/training-registration`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseAnonKey}`
      },
      body: JSON.stringify(data)
    })
    return response.json()
  },

  // Kimlik doğrulama
  async auth(action: 'signup' | 'signin' | 'signout', data?: {
    email?: string
    password?: string
    full_name?: string
  }) {
    const response = await fetch(`${supabaseUrl}/functions/v1/auth-handler`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseAnonKey}`
      },
      body: JSON.stringify({ action, ...data })
    })
    return response.json()
  }
}
